module.exports = __webpack_public_path__ + "img/logo_branca.134923fe.svg";